import React, { useEffect, useState } from "react";
import { Loader } from "rsuite";
import {
  AngleDown,
  AngleUp,
  arrowLeft,
  arrowRight,
  chevronLeft,
  chevronRight,
} from "../../assets/svgIcons";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const TableLayout = ({ headers, data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [paginatedData, setPaginatedData] = useState([]);
  const [originalData, setOriginalData] = useState(data);
  const [page, setPage] = useState(1);
  const [pageTwo, setPageTwo] = useSearchParams(
    { q: 1 },
    { replace: true, state: location?.state }
  );
  const [pagesNumber, setPagesNumber] = useState();
  const [searchQuery, setSearchQuery] = useState({});
  const [sortQuery, setSortQuery] = useState({});
  const [number, setNumber] = useState(10);
  useEffect(() => {
    setOriginalData(data);
  }, [data]);
  useEffect(() => {
    if (
      data &&
      data?.length &&
      Array?.isArray(data) &&
      originalData &&
      originalData?.length &&
      Array.isArray(originalData)
    ) {
      setPagesNumber(Math.ceil(originalData?.length / number));

      setPaginatedData(
        originalData?.filter(
          (item, index) =>
            index >= (parseInt(pageTwo.get("q")) - 1) * number &&
            index <= parseInt(pageTwo.get("q")) * number
        )
      );
    } else {
      setPaginatedData([]);
    }
  }, [pageTwo, originalData, number, data]);

  useEffect(() => {
    setPageTwo({ q: 1 }, { replace: true, state: location?.state });
  }, [number]);
  useEffect(() => {
    searchFunction();
  }, [searchQuery]);
  useEffect(() => {
    if (sortQuery.type == "asc") {
      sortAscFunction();
    } else if (sortQuery.type == "dsc") {
      sortDscFunction();
    }
  }, [sortQuery]);

  const getPageButtons = () => {
    if (pagesNumber <= 5) {
      return Array.from({ length: pagesNumber }, (_, i) => i + 1);
    } else if (parseInt(pageTwo.get("q")) <= 3) {
      return [1, 2, 3, "...", pagesNumber];
    } else if (parseInt(pageTwo.get("q")) > pagesNumber - 2) {
      return [1, "...", pagesNumber - 2, pagesNumber - 1, pagesNumber];
    } else {
      return [
        1,
        "...",
        parseInt(pageTwo.get("q")) - 1,
        parseInt(pageTwo.get("q")),
        parseInt(pageTwo.get("q")) + 1,
        "...",
        pagesNumber,
      ];
    }
  };
  const searchFunction = () => {
    if (searchQuery?.value && searchQuery?.value?.length) {
      let arr = [];
      let uniqueItems = new Set(); // Use a Set to keep track of unique items

      data?.forEach((item) => {
        if (
          item[searchQuery?.dataIndex] &&
          item[searchQuery?.dataIndex]?.length
        ) {
          if (searchQuery?.equal) {
            if (
              item[searchQuery?.dataIndex] === searchQuery?.value &&
              !uniqueItems.has(item)
            ) {
              arr.push(item);
              return uniqueItems.add(item);
            } else {
              setOriginalData([]);
            }
          } else {
            if (
              item[searchQuery?.dataIndex]?.includes(searchQuery?.value) &&
              !uniqueItems.has(item)
            ) {
              arr.push(item);
              return uniqueItems.add(item);
            }
          }
        } else {
          setOriginalData([]);
        }
      });
      setOriginalData([...arr]);
      if (arr?.length) {
        setPageTwo(
          {
            q: 1,
          },
          { replace: true, state: location?.state }
        );
      } else {
        setOriginalData([]);
      }
    } else {
      setOriginalData(data);
    }
  };
  const sortAscFunction = () => {
    if (sortQuery?.dataIndex && sortQuery?.dataIndex?.length) {
      // alert("Sorted ASC");
      setOriginalData((prevData) => {
        return [...prevData].sort((a, b) => {
          return !isNaN(a[sortQuery?.dataIndex]) &&
            !isNaN(b[sortQuery?.dataIndex])
            ? parseInt(b[sortQuery?.dataIndex]) -
            parseInt(a[sortQuery?.dataIndex])
            : b[sortQuery?.dataIndex]?.localeCompare(a[sortQuery?.dataIndex]);
        });
      });
    }
  };
  const sortDscFunction = () => {
    if (sortQuery?.dataIndex && sortQuery?.dataIndex?.length) {
      // alert("Sorted DSC");
      setOriginalData((prevData) => {
        return [...prevData].sort((a, b) => {
          return !isNaN(a[sortQuery?.dataIndex]) &&
            !isNaN(b[sortQuery?.dataIndex])
            ? parseInt(a[sortQuery?.dataIndex]) -
            parseInt(b[sortQuery?.dataIndex])
            : a[sortQuery?.dataIndex]?.localeCompare(b[sortQuery?.dataIndex]);
        });
      });
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
      {/* Table Container */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
            <tr>
              {headers.map((header, index) =>
                header?.label && header?.label?.length ? (
                  <th
                    key={index}
                    className="px-6 whitespace-nowrap py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                  >
                    <div className="flex items-end space-x-2">
                      <div className="flex gap-1 flex-col">
                        <span className="flex-1">{header?.label}</span>

                        {/* Search Input */}
                        {header?.search && (
                          <div className="relative">
                            <input
                              type="search"
                              placeholder="Search..."
                              className="w-32 px-3 py-1.5 text-xs border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                              onKeyUp={(e) => {
                                setSearchQuery({
                                  ...searchQuery,
                                  dataIndex: header.dataIndex,
                                  value: e.target.value,
                                  equal: header?.equal,
                                });
                              }}
                              onChange={(e) => {
                                setSearchQuery({
                                  ...searchQuery,
                                  dataIndex: header.dataIndex,
                                  value: e.target.value,
                                  equal: header?.equal,
                                });
                              }}
                            />
                          </div>
                        )}
                      </div>
                      {/* Sort Button */}
                      {header?.sort && (
                        <button
                          onClick={() => {
                            if (header?.sort) {
                              if (header.asc) {
                                setSortQuery({
                                  dataIndex: header?.dataIndex,
                                  type: "dsc",
                                });
                                header.asc = false;
                              } else {
                                setSortQuery({
                                  dataIndex: header?.dataIndex,
                                  type: "asc",
                                });
                                header.asc = true;
                              }
                            }
                          }}
                          className="p-1.5 rounded-lg hover:bg-gray-200 transition-colors duration-200 group"
                        >
                          <div className="w-4 h-4 text-gray-500 group-hover:text-gray-700 transition-colors duration-200">
                            {header?.asc && header?.sort
                              ? AngleDown
                              : !header?.asc && header?.sort
                                ? AngleUp
                                : null}
                          </div>
                        </button>
                      )}
                    </div>
                  </th>
                ) : null
              )}
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            {!data ? (
              <tr>
                <td colSpan={headers.length} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-4">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                      <Loader size="md" />
                    </div>
                    <p className="text-gray-500 text-sm">Loading data...</p>
                  </div>
                </td>
              </tr>
            ) : data?.length && Array?.isArray(data) ? (
              paginatedData?.map((row, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition-colors duration-150 group"
                >
                  {headers?.map((column, columnIndex) => {
                    const dataIndex = column?.dataIndex;
                    const cellData = row[dataIndex];
                    if (column && column?.label && column?.label?.length)
                      return (
                        <td
                          key={columnIndex}
                          className="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                        >
                          {column?.type === "children" ? (
                            <div className="flex items-center">
                              {column?.children({
                                headers: column,
                                row: row,
                                index: index,
                                lastIndex: paginatedData?.length,
                              })}
                            </div>
                          ) : (
                            <span className="text-gray-700">{cellData}</span>
                          )}
                        </td>
                      );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} className="px-6 py-12 text-center">
                  <div className="flex flex-col items-center justify-center space-y-4">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6-4h6m2 5.291A7.962 7.962 0 0112 15c-2.34 0-4.47-.881-6.08-2.33" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-medium text-gray-900 mb-1">No data available</h3>
                      <p className="text-gray-500 text-sm">There are no records to display at this time.</p>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
        <div className="flex items-center justify-between">
          {/* Items per page selector */}
          <div className="flex items-center space-x-3">
            <span className="text-sm text-gray-700 font-medium whitespace-nowrap">Items per page:</span>
            <select
              name="rowNumbers"
              id="rowNumbers"
              onChange={(e) => setNumber(e.target.value)}
              className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white"
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="150">150</option>
              <option value="200">200</option>
              <option value="250">250</option>
              <option value="300">300</option>
              <option value="350">350</option>
              <option value="400">400</option>
              <option value="450">450</option>
              <option value="500">500</option>
              <option value="1000">1000</option>
            </select>
          </div>

          {/* Pagination controls */}
          {data && data?.length && Array?.isArray(data) ? (
            <div className="flex items-center space-x-2">
              {/* Previous button */}
              <button
                className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                onClick={() =>
                  setPageTwo(
                    {
                      q:
                        pageTwo.get("q") > 1
                          ? parseInt(pageTwo.get("q")) - 1
                          : pageTwo.get("q"),
                    },
                    { replace: true, state: location?.state }
                  )
                }
                disabled={pageTwo.get("q") <= 1}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  {chevronLeft}
                </div>
              </button>

              {/* Page numbers */}
              <div className="flex items-center space-x-1">
                {getPageButtons().map((button, index) => (
                  <button
                    key={index}
                    className={`px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${button == parseInt(pageTwo.get("q"))
                      ? "bg-blue-600 text-white shadow-md"
                      : button === "..."
                        ? "text-gray-400 cursor-default"
                        : "text-gray-700 bg-white border border-gray-300 hover:bg-gray-50 hover:text-gray-900"
                      }`}
                    onClick={() =>
                      button == "..."
                        ? null
                        : setPageTwo(
                          {
                            q: button,
                          },
                          { replace: true, state: location?.state }
                        )
                    }
                    disabled={button === "..."}
                  >
                    {button}
                  </button>
                ))}
              </div>

              {/* Next button */}
              <button
                className="px-3 py-2 text-sm font-medium text-gray-500 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                onClick={() => {
                  setPageTwo(
                    {
                      q:
                        pageTwo.get("q") < pagesNumber
                          ? parseInt(pageTwo.get("q")) + 1
                          : pageTwo.get("q"),
                    },
                    { replace: true, state: location?.state }
                  );
                }}
                disabled={pageTwo.get("q") >= pagesNumber}
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  {chevronRight}
                </div>
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default TableLayout;
